import { Text } from "preact-i18n";

import { Modal } from "@revoltchat/ui";

import { noopTrue } from "../../../lib/js";

import { ModalProps } from "../types";

export default function DownloadError(props: ModalProps<"download_error">) {
    return (
        <Modal
            {...props}
            title={<Text id="app.special.modals.download_error.title" />}
            actions={[
                {
                    onClick: noopTrue,
                    confirmation: true,
                    children: <Text id="app.special.modals.actions.ok" />,
                },
            ]}>
            <Text
                id="app.special.modals.download_error.message"
                fields={{ error: props.error }}
            />
        </Modal>
    );
}
